export default function ProjectSettingsDataCategoryScreen() {
	return <div>ProjectSettingsDataCategoryScreen</div>;
}
